import React from "react";
import CustomFormatNumber from "components/CustomFormatNumber";

const FooterPropertyRow = ({ isMultiple = false, up, down, symbol = "%", performance }) => {
    const isNegative = performance < 0;
    const isDecimal = performance % 1 !== 0;

    return (
        <>
            <span className="text-12 primary-color fw-600">{up}</span>
            <span className="text-display text-no-break align-baseline">
                {performance && (
                    <span className={`text-16 mr-1 fw-600 ${isNegative ? "alert-red-color" : "green-color"}`}>
                        {isNegative ? "" : "+"}
                        <CustomFormatNumber value={performance} symbol="%" fixed={isDecimal ? 2 : 0} />
                    </span>
                )}
                <CustomFormatNumber value={down} noSymbol fixed={isMultiple ? 1 : 2} />{" "}
                <span className={`ml-2 ${isMultiple ? "text-18 fw-600" : "text-12 fw-500"}`}>{symbol}</span>
            </span>
        </>
    );
};

export default FooterPropertyRow;
